'use strict';

exports.__esModule = true;
var CONTEXT_PROPS = exports.CONTEXT_PROPS = {
  SITE_NAME: 'siteName',
  SITE_OG_IMAGE: 'siteOgImage',
  HOME_PAGE_TITLE: 'homePageTitle',
  IS_HOME_PAGE: 'isHomePage',
  PAGE_NAME: 'pageName',
  TITLE: 'title',
  DESCRIPTION: 'description',
  OG_TITLE: 'ogTitle',
  OG_DESCRIPTION: 'ogDescription',
  OG_IMAGE: 'ogImage',
  OG_IMAGE_WIDTH: 'ogImageWidth',
  OG_IMAGE_HEIGHT: 'ogImageHeight',
  DEFAULT_URL: 'defaultUrl',
  OG_TYPE: 'ogType',
  INDEX_SITE: 'indexSite',
  INDEX_PAGE: 'indexPage',
  FB_ADMINS: 'facebookAdminId',
  NEXT: 'nextLink',
  PREV: 'prevLink',
  CURR_LANG_CODE: 'currLangCode',
  CURR_LANG_IS_ORIGINAL: 'currLangIsOriginal',
  BUSINESS_NAME: 'businessName'
};